import {
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Loader
} from 'common/components';
import { WhatsNewLinkType } from 'modules/configuration/enums/configuration.enum';

import './WhatsNewLinkModal.scss';
import { useEffect, useState } from 'react';
import { ConfigurationService } from 'modules/configuration/redux/configuration.service';
import { useDispatch } from 'react-redux';
import { appStateActions } from 'common/redux/app-state';
import { IMAGE_FAILURE_ALT_MSG } from 'common/config/message.config';

type WhatsNewLinkModalProps = {
    show: boolean,
    onClose: () => void;
    data: any;
}

export default function WhatsNewLinkModal({ show, onClose, data }: WhatsNewLinkModalProps) {
    const [url, setUrl] = useState<string>('');
    const [imageLoaded, setImageLoaded] = useState(false);
    const dispatch = useDispatch();
    const imageComponent = () => {
        return (
            <>
                <img
                    className={imageLoaded ?
                        "whats-new-link-image-container" :
                        "whats-new-link-image-container-hidden"
                    }
                    src={url}
                    alt={IMAGE_FAILURE_ALT_MSG}
                    onLoad={() => setImageLoaded(true)}
                />
                <Loader isVisible={!imageLoaded} />
            </>
        );
    };

    const videoComponent = () => {
        return (
            <video width="100%" height="100%" controls>
                <source src={url} />
            </video>
        );
    };

    const detailsComponent = () => {
        return (
            <>
                <div className="details-wrapper">
                    <span className="title">Name:</span>
                    <span className="detail">{data?.name}</span>
                </div>
                <div className="details-wrapper">
                    <span className="title">Order:</span>
                    <span className="detail">{data?.order}</span>
                </div>
            </>
        );
    };

    const closeHandler = () => {
        onClose();
        setUrl('');
    };

    const getComponent = () => {
        switch (data?.whatsNewTypeId) {
            case WhatsNewLinkType.Image:
                return url !== '' ? imageComponent() : null;
            case WhatsNewLinkType.Video:
                return url !== '' ? videoComponent() : null;
            case WhatsNewLinkType.Indicator:
                return detailsComponent();
        }
    };

    useEffect(() => {
        if (
            data?.whatsNewTypeId &&
            (data?.whatsNewTypeId === WhatsNewLinkType.Image ||
                data?.whatsNewTypeId === WhatsNewLinkType.Video) &&
            show &&
            data?.link
        ) {
            (async () => {
                dispatch({
                    type: appStateActions.showLoader.type,
                    payload: true
                });
                const rawResp = await ConfigurationService.getConfigBlobSasUrl(
                    data?.link as string,
                    data?.whatsNewTypeId
                );
                if (rawResp) {
                    if (rawResp.hasErrors && rawResp.errors) {
                        setUrl('');
                    } else {
                        rawResp.value && setUrl(rawResp.value);
                    }
                    dispatch({
                        type: appStateActions.showLoader.type,
                        payload: false
                    });
                }
            })();
        }
    }, [data?.link, data?.whatsNewTypeId, dispatch, show]);
    return (
        <Modal
            show={show}
            onClose={onClose}
            className={data?.whatsNewTypeId === WhatsNewLinkType.Indicator ?
                "whats-new-link-container whats-new-link-indicator-container" :
                "whats-new-link-container"
            }
        >
            <ModalHeader>{data?.type}</ModalHeader>
            <ModalBody className="whats-new-link-body">{getComponent()}</ModalBody>
            <ModalFooter>
                <Button size="medium" variant="secondary" type="button" onClick={closeHandler}>
                    Cancel
                </Button>
            </ModalFooter>
        </Modal>
    )
}